export default __webpack_public_path__ + "static/media/system_view1.e06406a4.png";